import styled from 'styled-components';
import { shade } from 'polished';

export const BackgroundSection = styled.section`
  display: flex;
  flex-direction: column;
  margin: 50px;

  div.notMusic {
    max-width: 670px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    text-align: center;
    margin: 70px auto;

    svg {
      width: 400px;
      height: 270px;

      @media (max-width: 450px) {
        width: 100%;
        height: 100%;
      }
    }

    span {
      color: #fff;
      font-size: 30px;
      padding: 30px 0;
      font-family: 'UniviaRegular';
    }

    button {
      font-family: 'Roboto', sans-serif;
      color: #fafafa;
      font-size: 17px;
      background: linear-gradient(251.45deg, #f5134b 1.26%, #f34d21 96.99%);
      border-radius: 15px;
      outline: none;
      border: 0;
      padding: 0.5rem 3rem;

      &:hover {
        cursor: pointer;
        box-shadow: 0 0 2px 2px #f34d21;
      }
    }
  }

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.7rem;

    color: #ffffff;

    h1 {
      font-size: 35px;
      font-family: 'UniviaRegular';
    }

    div.inputIcon {
      position: relative;

      input {
        width: 150px;
        height: 30px;
        background: #222222;
        border: none;

        padding-left: 30px;
        color: #ffffff;
        font-size: 14px;
      }
      svg {
        position: absolute;
        left: 10px;
        top: 8px;
      }
    }

    @media (max-width: 500px) {
      h1 {
        font-size: 22px;
      }
    }
  }
  .viewMusic {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 36px;
    padding: 0.4rem 1.2rem;

    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.2;
    white-space: nowrap;
    color: #ffffff;

    background: transparent;
    border: 2px solid #f34d21;
    border-radius: 20px;
    cursor: pointer;
    transition: box-shadow 0.2s ease-out, background-color 0.2s ease-out;

    svg {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      margin: 0;
      color: #fe5812;
    }

    &:hover,
    &:focus-visible {
      outline: none;
      background-color: rgba(243, 77, 33, 0.12);
      box-shadow: 0 0 2px 2px #f34d21;
    }
  }

  div.scroll {
    overflow-x: auto;

    ::-webkit-scrollbar {
      height: 10px;
    }

    ::-webkit-scrollbar-track {
      background-color: #222222;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #696969;
      border-radius: 20px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background-color: #87868b;
    }

    @media (max-width: 700px) {
      display: none;
    }

    table {
      width: 100%;
      border-spacing: 0 8px;

      th {
        color: #c5c5c5;
        font-weight: normal;
        padding: 15px 25px;
        text-align: center;
        font-size: 15px;
        line-height: 24px;
        text-transform: uppercase;

        svg {
          margin: 0 5px 3px -20px;
        }
      }

      th.date {
        width: 190px;
      }

      tbody {
        tr {
          border-radius: 5px;
          border-style: solid;
          border-color: #272727;
          border-bottom-width: 20px;
          cursor: pointer;

          td {
            /* max-width: 200px; */
            padding: 15px 25px;
            font-size: 15px;
            font-weight: normal;
            text-align: center;
            color: #ffffff;
            background: #222222;
            transition: background-color 0.2s ease-out;
          }

          td.names {
            min-width: 140px;
            max-width: 220px;
            line-height: 1.4;
          }

          &:hover td {
            background: #2c2c2c;
          }

          &:hover .viewMusic {
            background-color: rgba(243, 77, 33, 0.12);
          }

          td#orange {
            color: #fe5812;

            button span {
              cursor: pointer;
              &:hover {
                color: ${shade(0.2, '#f25812')};
              }
            }
          }
          td#green {
            display: flex;
            flex-direction: column;

            button {
              border: 0;
              border-radius: 15px;
              display: flex;
              align-items: center;
              flex-direction: column;
              background: #32cd16;
              padding: 5px;

              span {
                color: #ffffff;
              }

              &:hover {
                span {
                  color: ${shade(0.2, '#ffffff')};
                }
              }
            }

          }
        }
      }
    }
  }

  ul.musicList {
    display: none;
    flex-direction: column;
    gap: 12px;
    margin: 20px 0 0;
    padding: 0;
    list-style: none;

    @media (max-width: 700px) {
      display: flex;
    }

    li {
      display: flex;
      flex-direction: column;
      background: #222222;
      border-radius: 8px;
      overflow: hidden;
    }

    button.musicCard {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
      width: 100%;
      padding: 16px;

      font-family: 'Roboto', sans-serif;
      text-align: left;
      color: #ffffff;

      background: none;
      border: 0;
      cursor: pointer;

      &:focus-visible {
        outline: 2px solid #fe5812;
        outline-offset: -2px;
      }

      &:active .viewMusic {
        background-color: rgba(243, 77, 33, 0.2);
      }
    }

    .musicCardTitle {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.3;
      overflow-wrap: anywhere;
    }

    .musicCardMeta {
      font-size: 14px;
      line-height: 1.4;
      color: #87868b;
    }

    .musicCardStatus {
      align-self: center;
      margin-top: 4px;
      font-size: 14px;
      color: #fe5812;

      &::first-letter {
        text-transform: uppercase;
      }
    }

    .viewMusic {
      width: 100%;
      min-height: 44px;
      margin-top: 10px;
      font-size: 16px;
    }

    button.musicCardCertificate {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      min-height: 44px;
      margin: 0 16px 16px;

      font-family: 'Roboto', sans-serif;
      font-size: 16px;
      color: #ffffff;

      background: #32cd16;
      border: 0;
      border-radius: 20px;
      cursor: pointer;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }

  @media (max-width: 700px) {
    margin: 30px 20px;
  }
`;
